var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.03,
    height: 20.03,
    viewBox: "0 0 20.03 20.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12985",
    "data-name": "Grupo 12985",
    transform: "translate(-1154.5 -697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Elipse_566",
    "data-name": "Elipse 566",
    d: "M9.015-1A10.015,10.015,0,0,1,19.03,9.015,10.015,10.015,0,0,1,9.015,19.03,10.015,10.015,0,0,1-1,9.015,10.015,10.015,0,0,1,9.015-1Zm0,18.209A8.194,8.194,0,1,0,.821,9.015,8.2,8.2,0,0,0,9.015,17.209Z",
    transform: "translate(1155.5 698)",
    fill: "#FF527B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_365",
    "data-name": "L\\xEDnea 365",
    d: "M-.09,4.463A.91.91,0,0,1-1,3.552V-.09A.91.91,0,0,1-.09-1a.91.91,0,0,1,.91.91V3.552A.91.91,0,0,1-.09,4.463Z",
    transform: "translate(1164.604 707.104)",
    fill: "#FF527B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_366",
    "data-name": "L\\xEDnea 366",
    d: "M-.08.821H-.09A.91.91,0,0,1-1-.09.91.91,0,0,1-.09-1H-.08a.91.91,0,0,1,.91.91A.91.91,0,0,1-.08.821Z",
    transform: "translate(1164.604 703.462)",
    fill: "#FF527B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamationIcon.2dc3587439c98c5756a9f8e0990091c5.svg";
export { ForwardRef as ReactComponent };